import { useEffect, useState } from "react";

/**
 * Slim, high-contrast progress bar pinned to the very top of the viewport.
 * Sits above the sticky header so it stays visible while scrolling.
 */
const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let frame = 0;

    const update = () => {
      frame = 0;
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(scrollable > 0 ? Math.min(100, (window.scrollY / scrollable) * 100) : 0);
    };

    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      if (frame) cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[1100] h-[3px] bg-transparent pointer-events-none"
      role="progressbar"
      aria-label="Page scroll progress"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progress)}
    >
      <div
        className="h-full origin-left"
        style={{
          width: `${progress}%`,
          background:
            "linear-gradient(90deg, hsl(var(--primary)) 0%, hsl(var(--primary-bright)) 55%, hsl(var(--secondary)) 100%)",
          boxShadow: "0 0 12px -2px hsl(var(--primary) / 0.7)",
          transition: "width 90ms linear",
        }}
      />
    </div>
  );
};

export default ReadingProgress;
